import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../../../../redux/store";
import { retrievePageMenu } from "../../../../redux/slice/page-menu.slice";
import { useDynamicScripts } from "../../../../hooks/useDynamicScript";
import LoadingComp from "../../../../components/re-usable/loading/loading";
import SectionChaptersLocalNetwork from "./chapters-local-network.component";
import SectionEventLocation from "./event-location.component";
//import SectionLandingBanners from "./landing-page.component";

const ChaptersLocalNetworksComponent = () => {
  const breadcrumbPath = "Membership%2FChapters-Local-Networks";
  const path = `%2F${breadcrumbPath}`;

  const dispatch = useAppDispatch();

  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [description, setDescription] = useState("");
  const [isChaptersLoaded, setIsChaptersLoaded] = useState(false);
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    dispatch(retrievePageMenu(path)).then(() => {
      setIsChaptersLoaded(true);
    });
  }, [dispatch]);

  useEffect(() => {
    if (isChaptersLoaded && RapsEuropeData[0]) {
      if (RapsEuropeData[0].result[0] && RapsEuropeData[0].result[0].description) {
        setDescription(RapsEuropeData[0].result[0].description);
        if (RapsEuropeData[0].result[0].javaScriptField) {
          setScriptHtmlString(RapsEuropeData[0].result[0].javaScriptField);
        }
      }
      setIsChaptersLoaded(false);
    }
  }, [isChaptersLoaded, RapsEuropeData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: description }}></div>
      <div className="widget">
        <SectionChaptersLocalNetwork />
        {/*<SectionLandingBanners />*/}
        <SectionEventLocation />
      </div>
      <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.councilDescription }}></div>
    </>
  );
};

export default ChaptersLocalNetworksComponent;